// Orders Actions
export const ordersActions = {
  FETCH_ORDERS: {
    REQUEST: 'orders/fetch-orders-request',
    SUCCESS: 'orders/fetch-orders-success',
    FAILURE: 'orders/fetch-orders-failure'
  },
  POST_ORDERS: {
    REQUEST: 'orders/post-orders-request',
    SUCCESS: 'orders/post-orders-success',
    FAILURE: 'orders/post-orders-failure'
  },
  DELETE_ORDER: {
    REQUEST: 'orders/delete-order-request',
    SUCCESS: 'orders/delete-order-success',
    FAILURE: 'orders/delete-order-failure'
  }
};

// Order Items Actions
export const orderItemsActions = {
  FETCH_ORDER_ITEMS: {
    REQUEST: 'orderItems/fetch-order-items-request',
    SUCCESS: 'orderItems/fetch-order-items-success',
    FAILURE: 'orderItems/fetch-order-items-failure'
  },
  POST_ORDER_ITEM: {
    REQUEST: 'orderItems/post-order-item-request',
    SUCCESS: 'orderItems/post-order-item-success',
    FAILURE: 'orderItems/post-order-item-failure'
  },
  DELETE_ORDER_ITEM: {
    REQUEST: 'orderItems/delete-order-item-request',
    SUCCESS: 'orderItems/delete-order-item-success',
    FAILURE: 'orderItems/delete-order-item-failure'
  }
};

// MPESA STK Push Actions
export const mpesaActions = {
  GENERATE_STK_PUSH: {
    REQUEST: 'mpesa/generate-stk-push-request',
    SUCCESS: 'mpesa/generate-stk-push-success',
    FAILURE: 'mpesa/generate-stk-push-failure'
  },
  PROCESS_STK_CALLBACK: {
    REQUEST: 'mpesa/process-callback-request',
    SUCCESS: 'mpesa/process-callback-success',
    FAILURE: 'mpesa/process-callback-failure'
  }
};

// Action Creators
export const generateStkPush = (paymentData) => ({
  type: mpesaActions.GENERATE_STK_PUSH.REQUEST,
  payload: paymentData
});

export const createOrder = (orderData) => ({
  type: ordersActions.POST_ORDERS.REQUEST,
  payload: orderData
});
